'use strict';
var BaseDeviceSettingsView = require('components/devices/views/common/base_device_settings_view');

var SettingsView = BaseDeviceSettingsView.extend({
    template: require('components/devices/templates/virtual/settings'),

    getInputFields: function () {
        return {
            name: {},
        };
    },

    getUpdatedModel: function (form) {
        return {
            name: form.name,
        };
    },
});

module.exports = SettingsView;
